module.exports = "/images/vendor/flag-icon-css/flags/1x1/gn.svg?1ce64523708a4513c00768eced01f5d5";